module.exports = __webpack_public_path__ + "img/section_2_asset.70fd06f4.png";